import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})

export class FooterComponent implements OnInit {

    listViewFooter: any;
    
    constructor(
    ) { }


    ngOnInit() {
        this.getListFotter();
    }

    getListFotter(){
        this.listViewFooter = [
            {
                detail: [
                    {
                        item: "Fondos y Retiro"
                    },
                    {
                        item: "Vida y familia"
                    },
                    {
                        item: "Salud"
                    },
                    {
                        item: "SOAT"
                    }
                    ,
                    {
                        item: "."
                    }
                    ,
                    {
                        item: "Protección de Datos Personales"
                    }
                ]
            },
            {
                detail: [
                    {
                        item: "Nosotros"
                    },
                    {
                        item: "Nuestro respaldo"
                    },
                    {
                        item: "."
                    },
                    {
                        item: "."
                    }
                    ,
                    {
                        item: "."
                    }
                    ,
                    {
                        item: "Políticas de privacidad"
                    }
                ]
            },
            {
                detail: [
                    {
                        item: "Beneficios"
                    },
                    {
                        item: "."
                    },
                    {
                        item: "."
                    },
                    {
                        item: "."
                    }
                    ,
                    {
                        item: "."
                    }
                    ,
                    {
                        item: "Términos y condiciones"
                    }
                ]
            },
            {
                detail: [
                    {
                        item: "Agencia virtual"
                    },
                    {
                        item: "."
                    },
                    {
                        item: "."
                    },
                    {
                        item: "."
                    }
                    ,
                    {
                        item: "."
                    }
                    ,
                    {
                        item: "Toda la información legal"
                    }
                ]
            }
        ]
    }

}
